/* eslint-disable react-refresh/only-export-components --
   Widget module: the FormWidget registration and its renderer are one plugin. */
import { useState } from "react";
import { FormWidgetService, FormWidgetProps } from "./form-widget-service";

// ── duration: a number and a unit, for a field of the checkpoint type Duration ──
// FEATURE-20261021-check-config-type-and-fileset-form
//
// The value is the duration in milliseconds (how the vm lays a Duration out in a form; the saved
// configuration holds its text, "1.5 s"); the person sees it in the largest unit that divides it,
// and may pick another. A blank number is no value, so a field with
// a default takes the default.

type Unit = { name: string; millis: number };
const UNITS: Unit[] = [
  { name: "ms", millis: 1 },
  { name: "s", millis: 1000 },
  { name: "min", millis: 60_000 },
  { name: "h", millis: 3_600_000 },
];

/** The largest unit that divides the duration evenly; ms for none. */
export function unitFor(millis: number): Unit {
  for (let i = UNITS.length - 1; i >= 0; i--) {
    if (millis !== 0 && millis % UNITS[i].millis === 0) return UNITS[i];
  }
  return UNITS[0];
}

function DurationWidget({ formItem, formData, setValue }: FormWidgetProps) {
  const raw = formData[formItem.name];
  const millis = typeof raw === "number" ? raw : null;
  // the unit the person picked; until then the largest that divides the value, whenever the value arrives
  const [chosen, setChosen] = useState<Unit | null>(null);
  const unit = chosen ?? (millis === null ? UNITS[0] : unitFor(millis));
  const shown = millis === null ? "" : String(millis / unit.millis);
  return (
    <div className="duration-widget" style={{ display: "flex", gap: 6 }}>
      <input
        type="number"
        min={0}
        value={shown}
        disabled={formItem.disabled === true}
        onChange={(e) => {
          // typing fixes the unit shown, so the number does not reflow into another unit mid-edit
          if (!chosen) setChosen(unit);
          setValue(e.target.value === "" ? null : Number(e.target.value) * unit.millis);
        }}
        style={{ flex: 1 }}
      />
      <select
        value={unit.name}
        disabled={formItem.disabled === true}
        onChange={(e) => {
          // the number typed stays, and the new unit applies to it: 3 then "s" is 3 s
          const next = UNITS.find((u) => u.name === e.target.value) ?? UNITS[0];
          setChosen(next);
          if (millis !== null) setValue((millis / unit.millis) * next.millis);
        }}
        aria-label={`${formItem.label ?? formItem.name} unit`}
      >
        {UNITS.map((u) => (
          <option key={u.name} value={u.name}>
            {u.name}
          </option>
        ))}
      </select>
    </div>
  );
}

FormWidgetService.get().register({ name: "duration", render: (props) => <DurationWidget {...props} /> });
